import React, { Component } from 'react';
import { Header, Segment, Table } from 'semantic-ui-react';
import { IBuilding } from '@relab/alstom-ptw-shared';

import { BuildingDeleteModal } from './BuildingDeleteModal';
import { BuildingUpsertModal } from './BuildingUpsertModal';
import { TranslationComponent } from '../TranslationComponent';

interface BuildingsListComponentProps {
  buildings: IBuilding[];
}

interface BuildingsListComponentState {
  column: string;
  sortedBuildings: IBuilding[];
  direction: 'descending' | 'ascending';
}

export class BuildingsListComponent extends Component<BuildingsListComponentProps> {
  state: BuildingsListComponentState = {
    column: 'name',
    sortedBuildings: [],
    direction: 'ascending',
  };

  componentDidUpdate(prevProps: Readonly<BuildingsListComponentProps>) {
    if (this.props.buildings !== prevProps.buildings) {
      this.setState({
        sortedBuildings: this.props.buildings,
      });
    }
  }

  handleSort = (clickedColumn: string) => () => {
    const { buildings } = this.props;
    const { column, sortedBuildings, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        sortedBuildings: buildings.sort((a: any, b: any) => (a[clickedColumn] > b[clickedColumn] ? -1 : 1)),
        direction: 'ascending',
      });

      return;
    }

    this.setState({
      sortedBuildings: sortedBuildings.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    });
  };

  render() {
    const { column, direction, sortedBuildings } = this.state;

    return (
      <Segment>
        <Header as="h2">
          <TranslationComponent stringKey={'Building list ({{length}})'} values={{ length: sortedBuildings.length }} />
        </Header>

        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                <TranslationComponent stringKey={'Name'} />
              </Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedBuildings.map((building) => (
              <Table.Row key={building._id}>
                <Table.Cell>{building.name}</Table.Cell>
                <Table.Cell textAlign="right">
                  <BuildingUpsertModal building={building} />
                  <BuildingDeleteModal building={building} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}
